import React, { useState } from 'react';
import { MODAL } from '../../constants';
import AddNote from './ModalViews/AddNote';
import NotesList from './ModalViews/NotesList';
import PharmacyInfoContainer from './ModalViews/PharmacyInfoContainer';

export const ModalContext = React.createContext();

const PharmacyModalContent = ({ pharmacyId, initialContent }) => {
  const [modalContent, setModalContent] = useState(initialContent);

  return (
    <ModalContext.Provider
      value={{ modalContent, setModalContent, pharmacyId }}
    >
      {modalContent === MODAL.PHARMACY_INFO ? (
        <PharmacyInfoContainer />
      ) : modalContent === MODAL.NOTES_LIST ? (
        <NotesList />
      ) : modalContent === MODAL.ADD_NOTE ? (
        <AddNote />
      ) : null}
    </ModalContext.Provider>
  );
};

export default PharmacyModalContent;
